import { render, staticRenderFns } from "./intern.vue?vue&type=template&id=0536f7a4&scoped=true"
import script from "./intern.vue?vue&type=script&lang=js"
export * from "./intern.vue?vue&type=script&lang=js"
import style0 from "./intern.vue?vue&type=style&index=0&id=0536f7a4&prod&scss=true&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536f7a4",
  null
  
)

export default component.exports